<template>
    <div id="notification-modal" class="modal modal-md fade" tabindex="-1" aria-hidden="true" aria-labelledby="" style="z-index: 999999;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header border-0">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center">
                    <i
                        class="fa notification-icon mt-n4"
                        :class="{
                            'fa-solid fa-circle-xmark text-danger':
                                notificationStore.notification.type === NOTIFICATION_TYPE.ERROR,
                            'fa-solid fa-triangle-exclamation text-warning':
                                notificationStore.notification.type === NOTIFICATION_TYPE.WARNING,
                            'fa-solid fa-check text-success':
                                notificationStore.notification.type === NOTIFICATION_TYPE.SUCCESS,
                            'fa-solid fa-check text-info':
                                notificationStore.notification.type === NOTIFICATION_TYPE.INFO,
                        }"
                    ></i>
                    <p class="mt-3 fw-bold fs-5 text-dark" style="list-style: none;" v-html="notificationStore.notification.content"></p>
                </div>
                <div class="modal-footer border-0">
                    <PrimaryButton
                        v-if="notificationStore.notification.cancelText"
                        type="button"
                        class="fw-bold fs-6 text-secondary"
                        color="btn-outline-secondary"
                        @click="closeModal"
                    >
                        {{ notificationStore.notification.cancelText }}
                    </PrimaryButton>

                    <PrimaryButton
                        v-if="notificationStore.notification.submitText"
                        class="fw-bold fs-6"
                        :on-click="confirmModal"
                    >
                        {{ notificationStore.notification.submitText }}
                    </PrimaryButton>
                </div>
            </div>
        </div>
    </div>
    <div class="toast-container position-fixed top-0 end-0 p-3">
        <div
            id="notification-toast"
            class="toast align-items-center p-2"
            :class="{
                'text-bg-error toast-error': notificationStore.notification.type === NOTIFICATION_TYPE.ERROR,
                'text-bg-warning toast-warning': notificationStore.notification.type === NOTIFICATION_TYPE.WARNING,
                'text-bg-success toast-success': notificationStore.notification.type === NOTIFICATION_TYPE.SUCCESS,
                'text-bg-info toast-info': notificationStore.notification.type === NOTIFICATION_TYPE.INFO,
            }"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
        >
            <div class="d-flex">
                <div class="toast-body" v-html="notificationStore.notification.content"></div>
                <button
                    type="button"
                    class="btn-close btn-close-gray me-2 m-auto"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                ></button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useNotificationStore, NOTIFICATION_TYPE } from '@/stores/notification'
import { Modal, Toast } from 'bootstrap'
import PrimaryButton from '@/components/Buttons/PrimaryButton.vue'

const notificationStore = useNotificationStore()
const isConfirmed = ref(false)
let currentModalObject = null

onMounted(() => {
    currentModalObject = new Modal('#notification-modal')

    document.getElementById('notification-modal').addEventListener('hidden.bs.modal', () => {
        if (isConfirmed.value) {
            notificationStore.notification.onConfirm()
        } else {
            notificationStore.notification.onClose()
        }

        notificationStore.hideNotification()
    })

    document.getElementById('notification-toast').addEventListener('hidden.bs.toast', () => {
        if (isConfirmed.value) {
            notificationStore.notification.onConfirm()
        } else {
            notificationStore.notification.onClose()
        }

        notificationStore.hideNotification()
    })
})

notificationStore.onDisplay(() => {
    if (notificationStore.notification.asToast) {
        Toast.getOrCreateInstance('#notification-toast').show()
    } else {
        currentModalObject.show()
    }
})

notificationStore.onHide(() => {
    if (notificationStore.notification.asToast) {
        Toast.getOrCreateInstance('#notification-toast').hide()
    } else {
        currentModalObject.hide()
    }
})

function confirmModal() {
    isConfirmed.value = true
    currentModalObject.hide()
}

function closeModal() {
    isConfirmed.value = false
    currentModalObject.hide()
}
</script>

<style scoped>
.notification-icon {
    font-size: 5rem;
}
.modal-footer {
    justify-content: center;
}
</style>
